/**
 * @description Media Library Tree using RC-Tree
 * @author Pranav Ramachandran
 */

import React from 'react'
import Tree, { TreeNode } from 'rc-tree';
import 'assets/sass/tree.scss';
import { NODE_TYPES } from 'components/medialibrarymain/mediaLibrary.constant';

function ScTree(props) {
    const {
        treeData,
        setpwd, getNodeData,
        loadedKeys, refreshNode,
        expandedKeys,
        setupExpandedKeys,
        selectedKeys,
        setupSelectedKeys,
        checkable,
        disableCheckOnFolder,
        checkedKeys,
        setupCheckedKeys
    } = props.input;

    function onSelect(selectedKeys, info) {

        setupSelectedKeys(info);

        if (info.node.props.expanded && !info.node.props.selected) {

        } else {
            setupExpandedKeys(undefined, info, true);
        }
        if (info.selected) {
            setpwd(info.node.props.eventKey);
        } else {
            setpwd(-1);
        }
    };

    function onExpand(expandedKeyData, info) {
        setupExpandedKeys(expandedKeyData, info);
    }

    function onLoadData(treeNode) {
        return getNodeData(treeNode.props.eventKey)
    }

    // TO-DO - context-menu here
    function onRightClick(info) {
        if (info.node.props.children) {
            // refreshNode(info.node.props.eventKey, false);
        }
    }

    function onCheck(KeyData, info) {
        setupCheckedKeys(info);
    }

    const switcherIcon = obj => {
        if (obj.isLeaf) {
            if (obj.type === NODE_TYPES.FOLDER) {
                return (<i className="fa fa-minus tree-icon-expander"></i>)
            } else {
                return '';
            }
        }
        if (obj.expanded) {
            return (<i className="fa fa-minus tree-icon-expander"></i>)
        } else {
            return (<i className="fa fa-plus tree-icon-expander"></i>)
        }
    };

    const loop = (data) => {
        return data.map((item) => {
            if (item.children) {
                return (
                    <TreeNode title={item.name}
                        key={item.key}
                        disableCheckbox={disableCheckOnFolder && item.type === NODE_TYPES.FOLDER}
                        icon={<span className={item.type === NODE_TYPES.FOLDER ? "tree-icon-folder" : "tree-icon-file"}></span>}>
                        {loop(item.children)}
                    </TreeNode>)
            }
            return (
                <TreeNode title={item.name}
                    key={item.key}
                    isLeaf={item.isLeaf}
                    disableCheckbox={disableCheckOnFolder && item.type === NODE_TYPES.FOLDER}
                    icon={<span className={item.type === NODE_TYPES.FOLDER ? "tree-icon-folder" : "tree-icon-file"}></span>} />
            );
        });
    };
    const treeNodes = loop(treeData);
    

    return (
        <Tree
            className="dam-tree"
            onSelect={onSelect}
            onExpand={onExpand}
            showIcon
            loadedKeys={loadedKeys}
            expandedKeys={expandedKeys}
            selectedKeys={selectedKeys}
            checkedKeys={checkedKeys}
            loadData={onLoadData}
            onRightClick={onRightClick}
            checkable={checkable}
            onCheck={onCheck}
            switcherIcon={switcherIcon}>
            {treeNodes}
        </Tree>
    )
}
function areEqual(prevProps, nextProps) {
    return prevProps.input.treeVersion === nextProps.input.treeVersion;
}
export default React.memo(ScTree, areEqual)
